import { render } from "./MusterModal.vue?vue&type=template&id=2646bb10"
import script from "./MusterModal.vue?vue&type=script&lang=js"
export * from "./MusterModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__